import React from "react";

const GridInline = ({ children, margin, marginLeft, marginTop, marginRight, marginBottom, width, height, borderRight, padding, paddingLeft, paddingRight, paddingTop, paddingBottom, textAlign, verticalAlign, backgroundColor }) => {
    return (
        <div
            style={{
                display: "inline-block",
                margin: margin,
                marginLeft: marginLeft,
                marginTop: marginTop,
                marginRight: marginRight,
                marginBottom: marginBottom,
                width: width,
                height: height,
                borderRight: borderRight,
                padding: padding,
                paddingLeft: paddingLeft,
                paddingRight: paddingRight,
                paddingTop: paddingTop,
                paddingBottom: paddingBottom,
                textAlign: textAlign,
                verticalAlign: verticalAlign,
                backgroundColor: backgroundColor,
            }}
        >
            {children}
        </div>
    );
};

export default GridInline;
